<template>
  <section class="availability" id="availability-block">
    <div class="availability-cont">
      <h2>Availability</h2>
      <div class="loader" v-if="loading"/>
      <div class="message-box available" v-if="!loading && propertyAvailable && checkInDate && checkOutDate">
        Selected dates are available
      </div>
      <div class="message-box range" v-if="propertyAvailable && nights < minimumStayLength">
        You can <b>stay up to 7 nights</b> from this arrival date at no extra cost.
      </div>
      <div class="message-box unavailable" v-if="!loading && !propertyAvailable && checkInDate && checkOutDate && source !== 'Booking Com'">
        <svg v-if="isUtmEmail">
          <use xlink:href="#icon-clock"></use>
        </svg>
        {{ isUtmEmail ? 'Property in high demand. Oops, these dates are already gone!' : 'Selected dates are unavailable'}}
      </div>
      <div class="message-box add" v-if="!checkInDate || !checkOutDate">
        Add dates for prices
      </div>
      <div class="message-box discount" v-if="!loading && propertyAvailable && checkInDate && checkOutDate && price.members_discount && track.visitorEmailId !== '0'">
        £{{price.original_price - price.discount_price}} member discount applied
      </div>
      <select v-model="nightsState">
        <option disabled>
          Popular durations
        </option>
        <option value="2">
          2 nights
        </option>
        <option value="3">
          3 nights
        </option>
        <option value="4">
          4 nights
        </option>
        <option value="5">
          5 nights
        </option>
        <option value="7">
          7 nights
        </option>
        <option disabled>
          Other durations
        </option>
        <option v-for="index in 28" :key="index" :value="index">
          {{ index }} night<span v-if="index > 1">s</span>
        </option>
      </select>
      <div v-picker id="calendar-container" class="calendar" ref="prop-calendar"/>
      <div class="info">{{
          owner ? "Enquire for accurate prices" :
              source === 'Booking Comx' ? "Selected dates will open in a new tab, for our sister site LateRooms.com" :
                  "Prices shown are for the total duration of your stay and updated every hour"
        }}</div>
    </div>
  </section>
</template>
<script>

export default {
  data() {
    return {
      nightsState: this.nights,
      datesWithPricesArrayData: [],
    };
  },
  props: {
    nights: String,
    loading: Boolean,
    checkInDate: String,
    checkOutDate: String,
    availableDates: Object,
    availableDatesWithPrices: Object,
    propertyAvailable: Boolean,
    minimumStayLength: Number,
    track: Object,
    price: Object,
    owner: Boolean,
    source: String,
    isUtmEmail: Boolean,
  },
  directives: {
    'picker': {
      inserted: function(el, binding, vnode) {
        let that = vnode.context;
        let datesArray = that.availableDatesWithPrices;
        //disallow all past dates
        let date = new Date();
        let yesterday = date.setDate(date.getDate() - 1);
        let yesterdate = new Date(yesterday).toISOString().split("T")[0];
        const disallowedDates = [['2001-01-01', yesterdate]];

        that.picker = el.picker;

        el.picker = new Litepicker({
          element: document.getElementById('calendar-container'),
          startDate: that.checkInDate,
          endDate: that.checkOutDate,
          singleMode: true,
          selectForward: true,
          highlightedDays: [],
          disallowLockDaysInRange: true,
          autoApply: true,
          resetButton: false,
          inlineMode: true,
          numberOfColumns: 2,
          numberOfMonths: 2,
          switchingMonths: 1,
          lockDays:disallowedDates,
          format: "D MMM YYYY",
          lockDaysFilter: (date1) => {
            let noAvail = datesArray.checkin_days[that.nightsState];
            let stayDates = datesArray.stay_days;

            if (stayDates) {
              if (typeof noAvail !== "undefined" && noAvail.length !== 0 || stayDates !== "undefined" && stayDates.indexOf(date1.format('YYYY-MM-DD') !== -1)) {
                return !stayDates.includes(date1.format('YYYY-MM-DD'));
              }
            }
          },
          setup: (picker) => {
            picker.on('render:day', (day, date) => {
              let isHighlighted = day.classList.contains("is-highlighted");

              let dataTime = date.dateInstance.getTime();
              let tabIndex = day.attributes.tabIndex.value;
              let pricesArray = that.datesWithPricesArrayData;

              if (dataTime in pricesArray) {
                if (isHighlighted) {
                  let prices = pricesArray[dataTime];

                  day.classList.toggle("has-deal", that.dealSaving(prices) > 0);

                  day.innerHTML = "<span>" + day.innerHTML + "</span>" + that.priceMarkup(prices) + "<div class='primary-overlay'></div><div class='day-item day-item-child' data-time=" + dataTime + " tabindex=" + tabIndex + "/>"
                }
              } else {
                day.innerHTML = "<span>" + day.innerHTML + "</span><div class='primary-overlay'></div><div class='day-item day-item-child' data-time=" + dataTime + " tabindex=" + tabIndex + "/>"
              }
            });
            picker.on('preselect', (date1) => {
              if (date1) {
                let checkout = new Date(date1.dateInstance);
                checkout.setDate(checkout.getDate() + parseInt(that.nightsState));
                picker.setDateRange(date1, checkout)
                that.$emit('update', date1.dateInstance, checkout)
              }
              if(that.source === 'Booking Com') {
                // that.navigateToLR()
              }

            });
            picker.on('change:month', () => {
              this.$emit('sendTrack', "click-change-month", true)
            });
          },
        });
      },
    }
  },
  watch: {
    nightsState() {
      let picker = this.$refs["prop-calendar"].picker;
      let highlightedDates = this.availableDates.checkin_days[this.nightsState];
      document.getElementById("booking_nights").value = this.nightsState;

      this.setPrices();

      if (highlightedDates) {
        picker.setOptions({
          highlightedDays: highlightedDates
        });
      } else {
        picker.setOptions({
          highlightedDays: []
        });
      }

      this.$emit('updateNights', this.nightsState, (checkInDate, checkOutDate) => {
        if (checkInDate && checkOutDate) {
          picker.setDateRange(checkInDate, checkOutDate);
        }
      });

      if(this.source === 'Booking Com') {
        // this.navigateToLR()
      }
    }
  },
  methods: {
    setPrices() {
      let datesWithPrices = this.availableDatesWithPrices.checkin_days[this.nightsState];
      let datesWithPricesArray;


      if (datesWithPrices) {
        datesWithPricesArray = datesWithPrices.reduce((acc, el) => {
          let key = Object.keys(el)[0];
          key = new Date(key).getTime();

          if (key in acc) {
            return acc;
          }

          acc[key] = el[Object.keys(el)[0]];
          return acc;
        }, {})
        this.datesWithPricesArrayData = datesWithPricesArray;
      }
    },
    dealSaving(prices) {
      // A missing or zero discounted price means the supplier gave us no deal,
      // not a 100% saving - see Indexing::ApiPricingNightPricesService
      if (!(prices.price > 0) || !(prices.discounted > 0)) {
        return 0;
      }

      return prices.price - prices.discounted;
    },
    priceMarkup(prices) {
      let saving = this.dealSaving(prices);

      if (saving <= 0) {
        let price = prices.price > 0 ? prices.price : prices.discounted;

        return price > 0 ? "<span class='price'>£" + price + "</span>" : "";
      }

      return "<span class='price'>£" + prices.discounted + "</span>" +
        "<i class='deal-flag'><svg aria-hidden='true'><use xlink:href='#icon-price-tag'></use></svg></i>" +
        "<i class='deal-tooltip'>Save £" + saving + "</i>";
    },
    navigateToLR() {
      this.$emit('navigateToLR')
    },
  },
  beforeMount() {
    this.setPrices();
  },
  mounted() {
    let picker = this.$refs["prop-calendar"].picker;
    let highlightedDates = this.availableDates.checkin_days[this.nightsState];
    document.getElementById("booking_nights").value = this.nightsState;

    if (highlightedDates) {
      picker.setOptions({
        highlightedDays: highlightedDates
      });
    } else {
      picker.setOptions({
        highlightedDays: []
      });
    }
  }
}
</script>

<style lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.availability {
  margin: 1.25rem 0;
  padding: 0 1.25rem;

  .availability-cont {
    padding-bottom: 1.25rem;
    border-bottom: 1px solid #D9D9D9;

    h2 {
      font-size: 1.25rem;
      line-height: 1.25rem;

      margin: 1.25rem 0;
    }

    select {
      width: 100%;
      outline: none;
      margin-bottom: .625rem;
      max-width: 17.938rem;
      padding: 1rem 0.625rem;
      border-radius: .625rem;
      border: 1px solid #D9D9D9;
      -webkit-appearance: none;
      -moz-appearance: none;
      background-size: 1.25rem 1.25rem;
      background-clip: border-box;
      background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg version='1.1' width='20px' height='20px' viewBox='0 0 20.0 20.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3CclipPath id='i0'%3E%3Cpath d='M1366,0 L1366,5230 L0,5230 L0,0 L1366,0 Z'%3E%3C/path%3E%3C/clipPath%3E%3CclipPath id='i1'%3E%3Cpath d='M10,0 C15.5228475,-1.01453063e-15 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 6.76353751e-16,15.5228475 0,10 C-6.76353751e-16,4.4771525 4.4771525,1.01453063e-15 10,0 Z'%3E%3C/path%3E%3C/clipPath%3E%3CclipPath id='i2'%3E%3Cpath d='M4.74106278,0.16518017 C4.88693184,0.286421989 4.97866324,0.46064445 4.99607733,0.649520372 C5.01349143,0.838396294 4.95516182,1.02645381 4.83392,1.17232289 L1.64106267,5.00089441 L4.72677674,8.82946627 C4.81412183,8.93431262 4.86960548,9.06198413 4.88666228,9.19737611 C4.90371908,9.3327681 4.8816356,9.47021389 4.82302427,9.59344796 C4.76441294,9.71668203 4.67172721,9.82054726 4.55593416,9.89275455 C4.44014111,9.96496185 4.30608693,10.0024886 4.16963407,10.0009435 C4.06292351,10.0012572 3.95748786,9.97770573 3.86107411,9.93197101 C3.76466036,9.88623628 3.67971883,9.81947998 3.6124914,9.7366081 L0.162491458,5.45089449 C0.0574330347,5.32308519 0,5.16276924 0,4.9973229 C0,4.83187656 0.0574330347,4.67156061 0.162491458,4.54375131 L3.73392003,0.258037405 C3.85516186,0.112168342 4.02938396,0.0204365903 4.21825988,0.00302249998 C4.4071358,-0.0143915904 4.59519371,0.0439383515 4.74106278,0.16518017 Z'%3E%3C/path%3E%3C/clipPath%3E%3C/defs%3E%3Cg transform='translate(-398.0 -942.0)'%3E%3Cg clip-path='url(%23i0)'%3E%3Cg transform='translate(140.0 803.0)'%3E%3Cg transform='translate(1.0 125.0)'%3E%3Cg transform='translate(257.0 34.0) rotate(-90.0)'%3E%3Cg clip-path='url(%23i1)'%3E%3Cpolygon points='0,0 20,0 20,20 0,20 0,0' stroke='none' fill='%23fa4351'%3E%3C/polygon%3E%3C/g%3E%3Cg transform='translate(7.142857142857142 5.0)'%3E%3Cg clip-path='url(%23i2)'%3E%3Cpolygon points='0,-4.96183624e-11 4.99909985,-4.96183624e-11 4.99909985,10.0009893 0,10.0009893 0,-4.96183624e-11' stroke='none' fill='%23FFFFFF'%3E%3C/polygon%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: calc(100% - 10px);
    }

    .message-box {
      width: auto;
      max-width: max-content;
      padding: 0.625rem .75rem;
      border-radius: .25rem;
      margin: .625rem 0;
      font-size: 0.875rem;
      line-height: 1rem;
      display: flex;
      align-items: center;
      flex-direction: row;

      svg {
        width: 100%;
        min-width: 2rem;
        max-width: 2rem;
        height: 2rem;
        margin-right: 1.25rem;

        @media(min-width: 549px) {
          height: 1rem;
          min-width: 1rem;
          max-width: 1rem;
          margin-right: 0.5rem;
        }
      }

      &.available {
        color: $col_white;
        background: #309975;
      }

      &.range {
        color: #D02E2E;
        background: #FFF8DC;
      }

      &.unavailable {
        color: $col_white;
        background: #E65657;
      }

      &.add {
        color: $col_white;
        background: #FF8050;
      }

      &.discount {
        color: $col_purple;
        background: #ebe7f2;
        border: 1px solid $col_purple;
      }
    }

    .calendar {
      padding-bottom: 2rem;
      max-width: 450px;
      margin: auto;

      .litepicker {
        width: 100%;
        font-family: 'DM Sans', sans-serif;
        position: relative!important;

        .container {
          &__main {
            width: 100%;
            height: 100% !important;
          }

          &__months {
            width: 100%;
            max-width: unset;
            box-shadow: none;
            flex-direction: column;
            background: transparent;

            .month-item {
              width: 100%;
              box-sizing: border-box;

              &:first-of-type {
                padding-bottom: 0.625rem;
              }

              &-header {
                padding-bottom: 1.375rem;

                .month-item {
                  &-name {
                    position: relative;
                    width: max-content;
                    margin: auto;

                    &:after {
                      bottom: 0;
                      right: -0.313rem;
                      content: ",";
                      display: block;
                      font-size: 1rem;
                      font-weight: 600;
                      position: absolute;
                      width: max-content;
                      line-height: 1.118rem;
                    }
                  }

                  &-name, &-year {
                    display: block;
                    font-size: 1rem;
                    font-weight: 600;
                    line-height: 1.118rem;
                    letter-spacing: -0.03rem;
                  }
                }

                .button-next-month, .button-previous-month {
                  cursor: pointer;

                  svg {
                    fill: $col_black;
                  }
                }

                .button-next-month {
                  right: 0.625rem;
                  top: 1.25rem;
                  position: absolute;
                }

              }

              &-weekdays-row {
                margin-bottom: 1.25rem;

                div {
                  color: #758EA1;
                  font-size: 0.75rem;
                  line-height: 0.625rem;
                  letter-spacing: -0.018rem;
                }
              }
            }
          }

          &__days {
            row-gap: 0.313rem;
            column-gap: 5px;

            div {
              width: calc(14.2857142857% - 5px);
              border-radius: 0.625rem;
            }

            &.disabled {
              text-decoration: line-through;
            }
          }
        }

        .day-item {
          height: 1.75rem;
          cursor: pointer;
          font-weight: 700;
          position: relative;
          background: #F6F6F2;
          display: flex;
          align-items: center;
          flex-direction: column;

          &.is-highlighted {
            box-shadow: inset 0 0 0 1px #ff784a;
          }

          &:hover {
            color: $col_primary;
            box-shadow: inset 0 0 0 1px $col_primary;
          }

          span {
            display: block;
            color: #323643;
            z-index: 10;

            &.price {
              font-weight: 700;
              font-size: 0.625rem;
              line-height: 0.813rem;
            }
          }

          .day-item-child {
            top: 0;
            left: 0;
            z-index: 15;
            width: 100%;
            opacity: .3;
            height: 100%;
            background: transparent;
            position: absolute;
          }

          .primary-overlay {
            top: 0;
            left: 0;
            z-index: 9;
            width: 100%;
            opacity: .3;
            height: 100%;
            background: transparent;
            position: absolute;
          }

          .deal-flag {
            top: 0.156rem;
            left: 0.156rem;
            z-index: 12;
            width: 0.75rem;
            height: 0.75rem;
            display: block;
            position: absolute;
            pointer-events: none;

            svg {
              width: 100%;
              height: 100%;
              display: block;
              fill: $col_primary;
            }
          }

          .deal-tooltip {
            left: 50%;
            z-index: 30;
            bottom: calc(100% + 0.375rem);
            position: absolute;
            padding: 0.188rem 0.375rem;
            border-radius: 0.25rem;
            background: #323643;
            color: $col_white;
            font-size: 0.625rem;
            font-style: normal;
            font-weight: 700;
            line-height: 0.875rem;
            white-space: nowrap;
            pointer-events: none;
            opacity: 0;
            visibility: hidden;
            transform: translate(-50%, 0.25rem);
            transition: opacity .15s ease-in-out, transform .15s ease-in-out, visibility .15s;

            &:after {
              content: "";
              top: 100%;
              left: 50%;
              position: absolute;
              margin-left: -0.25rem;
              border: 0.25rem solid transparent;
              border-top-color: #323643;
            }
          }

          &.has-deal {
            box-shadow: inset 0 0 0 1px $col_primary;

            // the spans' z-index only takes effect once they're positioned; without
            // this the tag paints over the day number rather than behind it
            > span {
              position: relative;
              z-index: 14;
            }

            &:hover {
              box-shadow: inset 0 0 0 1px $col_primary;
            }

            &:hover, &:focus-within {
              .deal-tooltip {
                opacity: 1;
                visibility: visible;
                transform: translate(-50%, 0);
              }
            }
          }

          &:nth-of-type(7), &:nth-of-type(14), &:nth-of-type(21), &:nth-of-type(28), &:nth-of-type(35) {
            &.is-in-range .primary-overlay {
              &:before {
                width: 100%;
              }
            }
          }

          &.is-start-date {
            &.is-end-date {
              .primary-overlay {
                &:before {
                  width: calc(100% + 5px);
                  border-radius: 0.625rem 0 0 0.625rem;
                }
              }
            }
          }

          &.is-end-date {
            .primary-overlay {
              &:before {
                width: 100%;
                border-radius: 0 0.625rem 0.625rem 0;
              }
            }
          }

          &.is-start-date, &.is-end-date {
            background: $col_primary;

            .primary-overlay {
              &:before {
                content: "";
                z-index: 0;
                background: $col_primary;
                height: 100%;
                opacity: 0.75;
                position: absolute;
                top: 0;
                left: 0;
              }
            }

            span {
              color: $col_white;
            }

            &:hover {
              color: $col_white;
              background: $col_primary;
            }
          }

          &.is-in-range {
            color: $col_white;
            background: #FF8050;

            .primary-overlay {
              &:before {
                content: "";
                z-index: 0;
                background: $col_primary;
                height: 100%;
                width: calc(100% + 5px);
                opacity: 0.75;
                position: absolute;
                top: 0;
                left: 0;
              }
            }

            span {
              color: $col_white;
            }

            &:hover {
              color: $col_white;
              background: #FF8050;
            }
          }

          &.is-start-date, &.is-end-date, &.is-in-range {
            .deal-flag svg {
              fill: $col_white;
            }
          }

          &.is-locked {
            text-decoration: line-through;
            text-decoration-color: #dedede;

            &.is-in-range, &.is-end-date, &.is-start-date {
              text-decoration-color: $col_white;
            }

            .day-item-child {
              cursor: default;
              box-shadow: none;
              color: var(--litepicker-is-locked-color);
            }

            span {
              color: #dedede;

              &.price {
                display: none;
              }
            }

            .deal-flag, .deal-tooltip {
              display: none;
            }

            &:hover {
              cursor: default;
              box-shadow: none;
              color: var(--litepicker-is-locked-color);
            }
          }
        }
      }
    }

    .loader {
      appearance: none;
      margin-right: 0;
      margin-bottom: .625rem;
      min-height: 2rem;
      min-width: 11.25rem;
      width: auto;
      height: auto;
      overflow: hidden;
      color: transparent !important;
      border: none !important;
      fill: transparent;
      text-shadow: none;
      box-sizing: border-box;
      box-shadow: none;
      will-change: background;
      background-color: #ccc;
      background-image: linear-gradient(90deg, #ddd 0, #e8e8e8 2.5rem, #ddd 5rem);
      background-size: 18.75rem;
      border-radius: 0.125rem;
      animation: shine-lines 1.6s infinite linear;
    }
  }

  .info {
    padding-top: 1rem;
    font-weight: 400;
    color: $col_black;
    padding-right: 5.5rem;
    font-size: 0.75rem;
    margin-top: -1.313rem;
  }

  // override
  .month-item-header {

    .month-item-name {
      display: inline!important;
      margin-right: 0.25rem!important;

      &:after {
        display: none!important;
      }
    }

    .month-item-year{
      display: inline!important;
    }
  }

  @media screen and (min-width: 768px) {
    .info {
      font-weight: 200;
      margin-top: -1rem;
    }

    .availability-cont {
      .calendar {
        max-width: unset;
        padding-bottom: 0;

        .litepicker {
          .container {
            &__months {
              flex-direction: row;

              .month-item {
                width: 50%;
                padding-bottom: 2rem;

                &-header {

                  .button-next-month {
                    top: unset;
                    right: unset;
                    position: relative;
                  }
                }
              }
            }
          }
        }
      }

      .message-box {
        margin: 1.25rem 0;

        &.range {
          margin-top: -.625rem;
        }
      }
    }
  }

  @media screen and (min-width: 1140px) {
    .availability-cont .calendar .litepicker .day-item span.price {
      font-size: .625rem;
    }
  }

  @media #{$desktop} {
    padding: 0;

    .availability-cont {
      h2 {
        font-size: 1.5rem;
        line-height: 1.813rem;
      }

      .calendar {
        max-width: unset;
        padding-bottom: 0;

        .litepicker {
          .container {
            &__months {
              .month-item {
                &:first-of-type {
                  padding-left: 0;
                }

                &:last-of-type {
                  padding-right: 0;
                }
              }
            }
          }
        }
      }
    }

    .availability-cont .calendar .litepicker .day-item span.price {
      font-size: 0.563rem;
    }
  }
}
</style>
